module.exports = __webpack_public_path__ + "img/angel.728981ec.svg";